import React, { useMemo } from 'react';
import { StateModal } from 'containers/Common/StateModal';
import { DefaultStateModalModel } from 'containers/Common/StateModalModel';
import { DraftCreateModalStateFactory } from './DraftCreateModalStateFactory';
import { Order } from 'core/order/Order';
import { L1Object } from 'core/l1Object/L1Object';

export const DraftCreateModal: React.FC<{
  order: Order;
  l1Object: L1Object;
  l2ObjectsToCreateDraft: {
    id: number | string;
    isDraft: boolean;
  }[];
  onClose: (dirty: boolean) => void;
}> = ({ order, l1Object, l2ObjectsToCreateDraft, onClose }) => {
  const draftCreateModalModel = useMemo(() => {
    const factoryModel = new DraftCreateModalStateFactory(
      order,
      l1Object,
      l2ObjectsToCreateDraft
    );
    return new DefaultStateModalModel(factoryModel, onClose, {
      order,
      l1Object: l1Object,
      l2ObjectsToCreateDraft: l2ObjectsToCreateDraft,
      targets: [
        {
          id: 0,
          numberOfCopies: 1,
          includeBinding: true
        }
      ]
    });
  }, [onClose, order, l1Object, l2ObjectsToCreateDraft]);

  return <StateModal model={draftCreateModalModel} />;
};
